export const toCurrencyID = (number = 0) => {
  if (typeof number !== "number") return "-";
  if (number === 0) return "0";

  const truncateDecimals = (val) => Math.floor(val * 100) / 100;

  // Triliun (T)
  if (number >= 1_000_000_000_000) {
    return `${truncateDecimals(number / 1_000_000_000_000).toLocaleString("id-ID", { maximumFractionDigits: 2 })} T`;
  }
  // Miliar (M)
  if (number >= 1_000_000_000) {
    return `${truncateDecimals(number / 1_000_000_000).toLocaleString("id-ID", { maximumFractionDigits: 2 })} M`;
  }
  // Juta (jt)
  if (number >= 1_000_000) {
    return `${truncateDecimals(number / 1_000_000).toLocaleString("id-ID", { maximumFractionDigits: 2 })} jt`;
  }
  // Ribu (rb)
  if (number >= 1_000) {
    return `${truncateDecimals(number / 1_000).toLocaleString("id-ID", { maximumFractionDigits: 2 })} rb`;
  }

  // Jika di bawah 1.000
  return number.toLocaleString("id-ID");
};

// Hasil Uji Coba:
// toCurrencyIDManual(500)       -> "500"
// toCurrencyIDManual(1500)      -> "1,5 rb"
// toCurrencyIDManual(2500000)   -> "2,5 jt"
// toCurrencyIDManual(1000000000)-> "1 M"